
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/enterprise/overview/project-based-learning",
      function () {
        return require("private-next-pages/enterprise/overview/project-based-learning.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/enterprise/overview/project-based-learning"])
      });
    }
  